import React from 'react';
import PropTypes from 'prop-types';
import { Col, Container, Nav, NavItem, Row } from 'reactstrap';
// import { NavLink } from 'react-router-dom';
import logoIcon from '../../../images/logo-icon.svg'

const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="footer-row">
          <Col xs="12" sm="auto">
            <a href="#" className="footer-logo">
              <span>Hubble</span>
              <img src={logoIcon} className="img-responsive" alt="logo" />
            </a>
          </Col>
          <Col>
            <Nav>
              <NavItem>
                <a href="https://hubbleiq.com/home/about" target="_blank">About</a>
              </NavItem>
              <NavItem>
                <a href="https://hubbleiq.com/home/blog" target="_blank">Blog</a>
              </NavItem>
              <NavItem>
                <a href="https://hubbleiq.com/privacy-policy" target="_blank">Privacy</a>
              </NavItem>
              <NavItem>
                <a href="https://hubbleiq.com/terms-conditions" target="_blank">Teams</a>
              </NavItem>
              <NavItem>
                <a href="mailto:contact@hubbleiq.com?subject=HubbleIQ Inquiry" target="_blank">Contact</a>
              </NavItem>
            </Nav>
          </Col>
        </Row>
        <div className="footer-copyright">© 2022 HubbleIQ Inc. All Rights Reserved.</div>
      </Container>
    </footer>
  );
};

Footer.propTypes = {};

export default Footer;
